import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { updateUrlSearchParams } from '@utils/search';
import logger from '@utils/logs';
import { AppliedFilterValue } from '@context';

interface UseFilterBuilderItemTextProps {
    paramName: string;
    appliedValue: string;
    setFilterValues: (values: AppliedFilterValue[]) => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useFilterBuilderText: (filter: UseFilterBuilderItemTextProps) => { search: string | null; setSearch: any } = (
    filter
) => {
    const location = useLocation();
    const navigate = useNavigate();

    const queryParams = new URLSearchParams(location.search);

    const [search, setSearch] = useState<string | null>(null);

    // if applied values change, refresh
    // this can be triggered when the filter is removed on AppliedFilters
    useEffect(() => {
        logger.log('hooks > useFilterBuilderText > appliedValues changed');

        if (filter.appliedValue.length === 0 && search !== null && search.length > 0) {
            setSearch('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter.appliedValue]);

    // initially, search gets values from the url search params
    useEffect(() => {
        logger.log('hooks > useFilterBuilderText > location.search changed', location.search);

        const getFilterParam = queryParams.get(filter.paramName);
        if (search !== getFilterParam) {
            setSearch(getFilterParam || '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    // update url and applied filters when values being searched change
    useEffect(() => {
        logger.log('hooks > useFilterBuilderText > search changed', { search });

        const getFilterParam = queryParams.get(filter.paramName);
        search !== getFilterParam && updateUrl(filter.paramName);

        // update applied filters (if they exist)
        if (search) {
            filter.setFilterValues([{ uuid: null, name: search || '' }]);
        } else {
            filter.setFilterValues([]);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const updateUrl = (paramName: string) => {
        if (search !== null) {
            const updatedUrl = updateUrlSearchParams({ [paramName]: search ? [search] : [] });
            logger.log('hooks > useFilterBuilderText > updateUrl', { paramName, updatedUrl });
            navigate(updatedUrl, { replace: true });
        }
    };

    return { search, setSearch };
};
